/** @typedef {'text'|'image'|'shape'|'group'} SceneNodeType */

/**
 * @typedef {Object} SceneTransform
 * @property {number} x
 * @property {number} y
 * @property {number} width
 * @property {number} height
 * @property {number} rotation
 * @property {number} scaleX
 * @property {number} scaleY
 * @property {string} originX
 * @property {string} originY
 * @property {number} [opacity]
 */

/**
 * @typedef {Object} SceneTypography
 * @property {string} fontFamily
 * @property {number} fontSize
 * @property {string} fontWeight
 * @property {string} fontStyle
 * @property {number} lineHeight
 * @property {number} letterSpacing
 * @property {string} textAlign
 * @property {string} fill
 * @property {boolean} [underline]
 */

/**
 * @typedef {Object} SceneConstraints
 * @property {string} layoutMode
 * @property {string} overflowStrategy
 * @property {number} minFontSize
 * @property {number} maxFontSize
 * @property {number} padding
 * @property {string} anchor
 */

/**
 * @typedef {Object} SceneClipBinding
 * @property {string} regionId
 * @property {'rect'|'path'} [shapeType]
 */

/**
 * @typedef {Object} SceneTextLayout
 * @property {string[]} lines
 * @property {number} fontSize
 * @property {number} contentWidth
 * @property {number} contentHeight
 * @property {number} [scale]
 */

/**
 * @typedef {Object} SceneNode
 * @property {string} id
 * @property {SceneNodeType} type
 * @property {SceneTransform} transform
 * @property {string} [fieldKey]
 * @property {Record<string, unknown>} [fieldConfig]
 * @property {SceneTypography} [typography]
 * @property {SceneConstraints} [constraints]
 * @property {string} [text]
 * @property {SceneTextLayout} [layout]
 * @property {SceneClipBinding} [clip]
 * @property {string} [src]
 * @property {string} [fill]
 * @property {string} [stroke]
 * @property {number} [strokeWidth]
 * @property {string} [fabricType]
 * @property {number} [zIndex]
 */

/**
 * @typedef {Object} SceneGraph
 * @property {number} version
 * @property {number} width
 * @property {number} height
 * @property {string} [background]
 * @property {SceneNode[]} objects
 */

export const SCENE_GRAPH_VERSION = 1;

export function createEmptyScene(width, height) {
  return {
    version: SCENE_GRAPH_VERSION,
    width: Math.max(1, width || 800),
    height: Math.max(1, height || 600),
    background: '#ffffff',
    objects: [],
  };
}

export function isTextSceneNode(node) {
  return node?.type === 'text';
}
